import translator from "@Components/Utilities/Translator";
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
const ComplexBreadcrumb = (props) => {

    const {
        BreadCrumbModels
    } = props;

    const getBreadCrumbCount = () => {
        return BreadCrumbModels ? BreadCrumbModels.length : 0;
    };
    const currentSite = useRecoilValue(atoms.currentWebsite);

    if (BreadCrumbModels && !currentSite.IsMobileAppContext) {
        return (
            <nav className='breadcrumbs' aria-label={translator.translate('sandhills.tradepubwebsite.mvc.breadcrumbs')}>
                <ul className='breadcrumbs__list'>
                    {BreadCrumbModels.map((breadCrumb, index) => {
                        let arrow = index === (getBreadCrumbCount() - 1) ? '' : '\u00A0>\u00A0';
                        let textLabel = breadCrumb.Label ? breadCrumb.Label.toUpperCase() : '';
                        let ariaLabel = index == 0 ? breadCrumb.Label ? breadCrumb.Label : '' : undefined;
                        return (
                            <li className='breadcrumbs__list-item' key={'breadcrumb-' + index}>
                                {breadCrumb.Url && BreadCrumbModels.length != index + 1 ?
                                    <a id={'breadcrumb-' + index} className='breadcrumbs__link' href={breadCrumb.Url} aria-label={ariaLabel}>
                                        {textLabel}
                                        {arrow}
                                    </a>
                                    :
                                    <p className='breadcrumbs__link' aria-label={ariaLabel}>
                                        {textLabel}
                                        {arrow}
                                    </p>
                                }
                            </li>
                        );
                    })}
                </ul>
            </nav>
        );
    } else {
        return (<></>);
    }
};

export default ComplexBreadcrumb;